//
//
//
//
//
//
//

export default {
  name: "PageHeader",
  props: {
    title: {
      type: String
    }
  }
}
